import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { Payee } from '../shared/sdk/models';
import { PayeeApi } from '../shared/sdk/services';
import { Router } from '@angular/router';
import { GlobalEventsManager } from '../events-manager.component'

@Component({
  selector: 'forgot-password',
  templateUrl: 'forgotPassword.component.html',
  styleUrls: ['login.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  private valid: boolean = true;

   @ViewChild('message') message: ElementRef;

  constructor(
    private userApi: PayeeApi,
    private router: Router,
    private eventsManager: GlobalEventsManager
  ) { }

  ngOnInit() { 
    if(this.userApi.isAuthenticated()){
      this.router.navigate(['/dashboard']);
    }
  }


  sendEmail(email) {
    var userEmail : any = {};

    userEmail['email'] = email;
    console.log("email");  
    console.log(email);
    if (email == '') {
      this.eventsManager.showPopUp("Email field is required");
    }
    else{
      this.userApi.resetPassword(userEmail).subscribe(res => { 
      this.invalidate();
      this.router.navigate(['/login']);
      this.eventsManager.showPopUp("A reset email has been successfully sent to "+email+".");
      
      }, 
      err => {
        this.invalidate();
        this.eventsManager.showPopUp("This email: "+email+" is not registered yet.");
        
      });

    }
    
  }

  invalidate() {
    this.valid = false;
  }

  close() {
    this.valid = true;
  }

}